import { render, staticRenderFns } from "./Werkplaatsen.vue?vue&type=template&id=f74615b6&scoped=true&"
import script from "./Werkplaatsen.vue?vue&type=script&lang=js&"
export * from "./Werkplaatsen.vue?vue&type=script&lang=js&"
import style0 from "./Werkplaatsen.vue?vue&type=style&index=0&id=f74615b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74615b6",
  null
  
)

export default component.exports